import { CheckboxLabel } from 'components/Input/Checkbox/styles'
import styled from 'styled-components'
import theme from 'theme_'

export const Terms = styled.div`
  display: flex;
  gap: 16px;
  ${CheckboxLabel} {
    height: fit-content;
  }

  @media ${theme.devices.tablet} {
    padding: 24px ${theme.spacing.xlarge} 0;
  }

  @media ${theme.devices.desktop} {
    padding-top: 32px;
  }
`

// TODO: move it to global styles?
export const StyledLink = styled.a`
  color: ${theme.colors.horizonOrange};
`

export const CheckoutInfoCenteredSpinner = styled.div`
  display: flex;
  justify-content: center;
  margin: 10px 0 20px;
`
